// extracted by mini-css-extract-plugin
export default {"header":"_1hehq","text":"Q-IWL"};